import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent, ButtonComponent, NebulaAccionDirective } from 'nebula-ui-kit';

export interface PageHeaderIcon {
  name: string;
  color?: string;
}

export interface PageAction {
  id: string;
  label: string;
  icon?: string;
  variant?: 'primary' | 'secondary' | 'danger';
  includeBorder?: boolean;
  disabled?: boolean;
  visible?: boolean;
  /**
   * Llave Flujo 2 para `nebulaAccion` (p. ej. SAVE, REJECT, VIEW).
   * Si no se define, el botón no aplica gate del kit.
   */
  accion?: string;
}

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule, IconComponent, ButtonComponent, NebulaAccionDirective],
  template: `
    <header class="page-header">
      <div class="header-title">
        <div class="header-text">
          <h1>
            @if (icon()) {
              <lib-icon
                [name]="$any(icon()!.name)"
                class="inline-icon"
                [class.custom-color]="icon()!.color !== undefined"
                [style.color]="icon()!.color"
                aria-hidden="true"
              />
            }
            {{ title() }}
          </h1>
          @if (subtitle()) {
            <p class="subtitle">{{ subtitle() }}</p>
          }
        </div>
      </div>

      <div class="header-actions">
        @for (action of actions(); track action.id) {
          @if (action.visible !== false) {
            <div class="action-button-wrapper desktop-only">
              @if (action.accion) {
                <lib-button
                  [variant]="action.variant || 'secondary'"
                  [includeBorder]="action.includeBorder"
                  [disabled]="action.disabled || false"
                  [prefixIcon]="$any(action.icon)"
                  [nebulaAccion]="action.accion"
                  (clicked)="actionClick.emit(action.id)"
                >
                  {{ action.label }}
                </lib-button>
              } @else {
                <lib-button
                  [variant]="action.variant || 'secondary'"
                  [includeBorder]="action.includeBorder"
                  [disabled]="action.disabled || false"
                  [prefixIcon]="$any(action.icon)"
                  (clicked)="actionClick.emit(action.id)"
                >
                  {{ action.label }}
                </lib-button>
              }
            </div>

            <div class="action-button-wrapper mobile-only">
              <div class="icon-button-with-tooltip" [attr.data-tooltip]="action.label">
                @if (action.accion) {
                  <lib-button
                    [variant]="action.variant || 'secondary'"
                    [includeBorder]="action.includeBorder"
                    [disabled]="action.disabled || false"
                    [prefixIcon]="$any(action.icon)"
                    [nebulaAccion]="action.accion"
                    (clicked)="actionClick.emit(action.id)"
                    class="icon-only-button"
                  >
                    <span class="sr-only">{{ action.label }}</span>
                  </lib-button>
                } @else {
                  <lib-button
                    [variant]="action.variant || 'secondary'"
                    [includeBorder]="action.includeBorder"
                    [disabled]="action.disabled || false"
                    [prefixIcon]="$any(action.icon)"
                    (clicked)="actionClick.emit(action.id)"
                    class="icon-only-button"
                  >
                    <span class="sr-only">{{ action.label }}</span>
                  </lib-button>
                }
              </div>
            </div>
          }
        }

        <ng-content select="[header-actions]"></ng-content>
      </div>
    </header>
  `,
  styleUrls: ['./page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
  title = input.required<string>();
  subtitle = input<string>();
  icon = input<PageHeaderIcon>();
  actions = input<PageAction[]>([]);
  actionClick = output<string>();
}
